import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import Loading from '@hems/component/src/loading/Loading.vue';
import ToastMessage from '@hems/component/src/toastMessage/ToastMessage.vue';
export default defineComponent({
    name: 'MainTemplate',
    components: {
        Loading,
        ToastMessage,
    },
    setup() {
        const store = useStore();
        const toastMessageInfo = computed(() => ({
            isShow: store.state.toast.isShow,
            message: store.state.toast.message,
            type: store.state.toast.type,
            isTOU: store.state.toast.isTOU,
        }));
        return { toastMessageInfo };
    },
});
